import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const IceDrinks = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Холоднi напоi'/>
            <main className={s.main}>
                <Product name='Мохіто' price='70 грн.' info1="лайм, цукровий сироп, м'ята, лаймовий сироп, спрайт, лід"/>
                <Product name='Лимонад' price='50 грн.' info1="лимон, цукросий сироп, м'ята, сироп на вибір, мінеральна вода, лід"/>
                <Product name='Гаваї' price='90 грн.' info1="апельсиновий сік, ананасовий сік, кокосовий сироп, лід"/>
                <Product name='Блакитна лагуна' price='80 грн.' info1="лимон, спрайт, лимонний сік, мед, сироп блю кюрасао, лід"/>
                <Product name='Ямайка' price='90 грн.' info1="апельсиновий сік, ананасовий сік, спрайт, сироп тропік, лід"/>
                <Product name='Малиновий коктель' price='80 грн.' info1="спрайт, малина, сироп малиновий, лід"/>
                <Product name='Апельсиновий коктель' price='80 грн.' info1="апельсиновий сік, спрайт, чай чорний, апельсин, сироп мультифрукт, лід"/>
            </main>
        </div>
    )
}

export default IceDrinks;